import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PermissionService } from '../../core/services/common/permission.service';
import { BaseFieldPermissionDirective } from './base-field-permission.directive';
import { FieldPermissionStyleService } from '../services/field-permission-style.service';

@Directive({
  selector: '[appFieldPermission]'
})
export class FieldPermissionDirective extends BaseFieldPermissionDirective implements OnInit {
  @Input() appFieldPermission: string = ''; 
  @Input() fieldBehavior: 'readonly' | 'obfuscate' = 'readonly';
  
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    permissionService: PermissionService,
    styleService: FieldPermissionStyleService
  ) {
    super(permissionService, styleService);
  }
  
  ngOnInit(): void {
    if (this.permissionService.isAdminRole()) {
      return;
    }
    
    const { canView, canWrite } = this.checkFieldPermission(this.appFieldPermission);
    
    if (canView && !canWrite) {
      this.applyReadonlyStyle();
    } else if (!canView) {
      this.applyObfuscatedStyle();
    }
  }
  
  private applyReadonlyStyle(): void {
    try {
      const inputElement = this.el.nativeElement;
      this.styleService.applyReadonlyStyle(inputElement, this.renderer);
    } catch (error) {
    }
  }
  
  private applyObfuscatedStyle(): void {
    try {
      const element = this.el.nativeElement;
      this.styleService.applyObfuscatedStyle(element, this.renderer);
    } catch (error) {
    }
  }
}
